(function HotelEngineProcessor($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('HotelEngine/processor', function onload() {
			window.addEventListener('beforeunload', beforeUnloadListener);
			processNextAction();
		});
	});

	function processNextAction()
	{
		var $processor = $('div.processor-content'),
		    url        = Adzuki.base_uri + '/HotelEngine/' + $processor.data('complete-action');

		Adzuki.Ajax.get('/HotelEngine/' + $processor.data('load-action'))
		.then(function success(data) {

			if (data.return_value === 'complete') {
				if (data.reservation_id && data.component_id) {
					url += '/' + data.reservation_id + '/' + data.component_id;
				}

				if (data.package_id) {
					url += '/' + data.package_id;
				}

				window.removeEventListener('beforeunload', beforeUnloadListener);
				window.location.href = url;
			}

			if (data['return_value'] === 'exception') {
				window.removeEventListener('beforeunload', beforeUnloadListener);
				window.location.href = Adzuki.base_uri + data['redirect_url'];
			}
		});
	}

	function beforeUnloadListener(event)
	{
		event.returnValue = `Are you sure you want to leave?`;
	}


}(jQuery, window.Adzuki || {}));
